import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { FileSignature } from 'lucide-react';

export const ConventionSignatureModal = ({ open, onOpenChange, convention, signatureData, setSignatureData, resetSignatureData, onSign }) => {
  return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileSignature className="h-6 w-6 text-green-600" />
              Signature électronique du convention
            </DialogTitle>
          </DialogHeader>

          {convention && (
            <div className="space-y-4 py-4">
              <div className="bg-blue-50 p-4 rounded border border-blue-200">
                <p className="font-semibold text-blue-900">{convention.titre}</p>
                <p className="text-sm text-blue-700">{convention.numero_contrat}</p>
                <p className="text-xs text-slate-600 mt-2">
                  Durée : {convention.duree_mois} mois
                  {convention.montant_mensuel && ` • ${convention.montant_mensuel} €/mois`}
                </p>
              </div>

              <div className="bg-yellow-50 border border-yellow-200 p-4 rounded">
                <p className="text-sm text-yellow-900 font-medium mb-2">
                  ⚠️ Important
                </p>
                <p className="text-xs text-yellow-800">
                  En signant ce convention électroniquement, vous acceptez d'être lié(e) par ses termes et conditions. 
                  Votre signature a la même valeur légale qu'une signature manuscrite.
                </p>
              </div>

              <div>
                <Label>Nom complet (signature électronique) *</Label>
                <Input
                  value={signatureData.signature_electronique}
                  onChange={(e) => setSignatureData({
                    ...signatureData,
                    signature_electronique: e.target.value
                  })}
                  placeholder="Prénom NOM"
                  className="mt-2"
                />
                <p className="text-xs text-slate-500 mt-1">
                  Saisissez votre nom complet tel qu'il apparaîtra sur le convention signé
                </p>
              </div>

              <div className="flex items-start gap-3 p-4 border rounded">
                <input
                  type="checkbox"
                  checked={signatureData.accepte_conditions}
                  onChange={(e) => setSignatureData({
                    ...signatureData,
                    accepte_conditions: e.target.checked
                  })}
                  className="h-5 w-5 mt-0.5 rounded border-gray-300 text-green-600 focus:ring-green-500"
                />
                <div>
                  <Label className="cursor-pointer text-sm">
                    J'ai lu et j'accepte les termes et conditions de ce convention de partenariat
                  </Label>
                  <p className="text-xs text-slate-500 mt-1">
                    Date et heure de signature : {new Date().toLocaleString('fr-FR')}
                  </p>
                </div>
              </div>
            </div>
          )}

          <DialogFooter>
            <Button variant="outline" onClick={() => {
              onOpenChange(false);
              resetSignatureData();
            }}>
              Annuler
            </Button>
            <Button
              className="bg-green-600 hover:bg-green-700"
              onClick={onSign}
            >
              <FileSignature className="h-4 w-4 mr-2" />
              Signer le convention
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};
